import {Provider} from "mobx-react";
import * as React from 'react';
import {hydrate, render} from "react-dom";
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import RootStore from "./stores/root-store";

const rootStore: RootStore = new RootStore();

const stores = {
    rootStore: rootStore,
    blogStore: rootStore.blogStore,
    cartStore: rootStore.cartStore,
    countryStore: rootStore.countryStore,
    emailStore: rootStore.emailStore,
    orderStore: rootStore.orderStore,
    productStore: rootStore.productStore,
    shippingStore: rootStore.shippingStore,
    sysStore: rootStore.sysStore,
    toasterStore: rootStore.toasterStore,
    translationStore: rootStore.translationStore
};

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
    hydrate(<Provider {...stores}>
            <App/>
        </Provider>,
        rootElement)
} else {
    render(<Provider {...stores}>
            <App/>
        </Provider>,
        rootElement)
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx